import _ from 'lodash';
import { many } from '@arc/shared/util-js';
/**
 * Convert a short hand PermissionsMetadataDef into a complete PermissionsMetadata.
 *
 * PermissionsMetadataDef is easier to write by hand,
 * but PermissionsMetadata is easier to process and use.
 */
// TODO Include transitive edges.
export function makePermissionMetadata(permissionTypes, actionTypes, x, superPerms) {
  const nodes = [];
  const edges = [];

  // Use the PermissionsMetadataDef to construct a directed graph of the permission's dependencies.
  for (const p of permissionTypes) {
    for (const a of actionTypes) {
      const m = x?.[p]?.[a] ?? {};
      if (m === 'unused') {
        continue;
      }
      nodes.push([p, a]);
      for (const n of many(m.needs)) {
        const nn = typeof n === 'string' ? [p, n] : n;
        edges.push([[p, a], nn]);
      }
    }
  }

  // Use the graph to construct PermissionsMetadata.
  const metadata = {};
  for (const p of permissionTypes) {
    for (const a of actionTypes) {
      if (!_.some(nodes, n => _.isEqual(n, [p, a]))) {
        _.set(metadata, [p, a], 'unused');
        continue;
      }
      const neededBy = [];
      for (const [neededBy_] of _.filter(edges, ([, needs]) => _.isEqual(needs, [p, a]))) {
        neededBy.push(neededBy_);
      }
      const needs = [];
      for (const [, needs_] of _.filter(edges, ([neededBy_]) => _.isEqual(neededBy_, [p, a]))) {
        needs.push(needs_);
      }
      _.set(metadata, [p, a], {
        needs,
        neededBy
      });
    }
  }

  // Create permissionSystem.superPermDeps
  const toCheckPerms = [...superPerms];
  const superPermDeps = [];
  let toCheckPerm = toCheckPerms.pop();
  while (toCheckPerm) {
    const alreadyChecked = superPermDeps.some(dep => _.isEqual(dep, toCheckPerm));
    if (!alreadyChecked) {
      superPermDeps.push(toCheckPerm);
    }
    const [P, A] = toCheckPerm;
    const permMetadata = metadata[P][A];
    if (permMetadata !== 'unused') {
      for (const need of permMetadata.needs) {
        const needAlreadyChecked = superPermDeps.some(dep => _.isEqual(dep, need));
        if (!needAlreadyChecked) {
          toCheckPerms.push(need);
        }
      }
    }
    toCheckPerm = toCheckPerms.pop();
  }
  return {
    permissionsMetadata: metadata,
    superPermDeps
  };
}